var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.209,
    height: 33.981,
    viewBox: "0 0 24.209 33.981",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "teeth-group",
    id: "Group_44",
    "data-name": "Group 44",
    transform: "translate(-260.625 -184.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_176",
    "data-name": "Subtraction 176",
    transform: "translate(260.625 185.609)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,16.725H0L.876,8.735l2.1-8.2L24.209,0V15.62L0,16.725Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.242642641067505 14.62030220031738 L 22.20911026000977 13.70937156677246 L 22.20911026000977 2.051036596298218 L 4.539257049560547 2.495081901550293 L 2.848339796066284 9.094366073608398 L 2.242642641067505 14.62030220031738 M -5.920410330872983e-07 16.72470474243164 L 0.0001294079556828365 16.72353363037109 L 0.8757094144821167 8.735404014587402 L 2.977209329605103 0.5337039232254028 L 24.20911026000977 0.0001438967883586884 L 24.20911026000977 15.62020397186279 L 0.001169407973065972 16.72464370727539 L -5.920410330872983e-07 16.72470474243164 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.5)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Subtraction_177",
    "data-name": "Subtraction 177",
    transform: "translate(263.127 203.191)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.831,15.59h0L0,6.067V.83L21.706.007v12.86l-1.376.323-18.5,2.4Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.43941855430603 13.3643798828125 L 19.70619964599609 11.25457286834717 L 19.70619964599609 2.084216594696045 L 1.99999988079071 2.75542426109314 L 1.99999988079071 5.876424789428711 L 3.43941855430603 13.3643798828125 M 1.830599784851074 15.58979892730713 L 1.830419778823853 15.5888786315918 L -1.770019508740006e-07 6.066908359527588 L -1.770019508740006e-07 0.8298084735870361 L 21.70619964599609 0.006968467496335506 L 21.70619964599609 12.86742877960205 L 20.33009910583496 13.19040870666504 L 1.831529855728149 15.58967876434326 L 1.830599784851074 15.58979892730713 Z",
    stroke: "none",
    fill: "rgba(255,255,255,0.5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Union_109",
    "data-name": "Union 109",
    d: "M1.811,1.2,23.186,0V9.477L-.131,9.5Z",
    transform: "translate(261.647 184.8)",
    fill: "#fec5c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_110",
    "data-name": "Union 110",
    d: "M-1.188,9.508l19.85-2.5V0L-3.032.023Z",
    transform: "translate(266.172 209.273)",
    fill: "#fec5c6"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "mask",
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(-293.624 -184.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union_108",
    "data-name": "Union 108",
    transform: "translate(293.624 184.8)",
    fill: "#2a3033"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fill",
    d: "M4.333,33.981h0L2.5,24.458V19.221L24.209,18.4v6.075h0v7.013l-11.465,1.4-8.41,1.091ZM0,17.534H0L.876,9.545l.948-3.7L2.834,1.2,24.209,0V16.43L0,17.534Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "border",
    d: "M 5.942473411560059 31.7559642791748 L 12.48726081848145 30.90706062316895 L 12.49435043334961 30.90615081787109 L 12.50144004821777 30.90528106689453 L 22.21000099182129 29.71646499633789 L 22.21000099182129 26.47369956970215 L 22.2091007232666 26.47369956970215 L 22.2091007232666 24.47369956970215 L 22.2091007232666 20.4759349822998 L 4.50290060043335 21.14694595336914 L 4.50290060043335 24.26792144775391 L 5.942473411560059 31.7559642791748 M 2.243196487426758 15.42947387695313 L 22.2091007232666 14.5186595916748 L 22.2091007232666 9.47700023651123 L 22.2091007232666 2.115486860275269 L 4.464969158172607 3.112146615982056 L 3.777480602264404 6.271790027618408 L 3.769710540771484 6.307539939880371 L 3.760620594024658 6.342990398406982 L 2.848352432250977 9.903378486633301 L 2.243196487426758 15.42947387695313 M 4.334400653839111 33.98130035400391 L 4.333500385284424 33.98130035400391 L 4.333500385284424 33.98040008544922 L 2.50290060043335 24.45840072631836 L 2.50290060043335 19.22130012512207 L 24.2091007232666 18.39870071411133 L 24.2091007232666 24.47369956970215 L 24.21000099182129 24.47369956970215 L 24.21000099182129 31.48649978637695 L 12.74452018737793 32.89044952392578 L 4.334400653839111 33.98130035400391 Z M 0.001800495898351073 17.53380012512207 L 4.95910626341356e-07 17.53380012512207 L 0.000900495913811028 17.53289985656738 L 0.8757004737854004 9.544500350952148 L 1.823210477828979 5.846570014953613 L 2.834100484848022 1.200600147247314 L 24.2091007232666 1.770019508740006e-07 L 24.2091007232666 9.47700023651123 L 24.2091007232666 16.42950057983398 L 0.001800495898351073 17.53380012512207 Z",
    stroke: "none",
    fill: "#fff",
    opacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideView);
export default __webpack_public_path__ + "static/media/SideView.1504e977e663c29a6a964ecf1ccc0b47.svg";
export { ForwardRef as ReactComponent };